export default function({ tag = "div", attributes = {}, html = undefined, text = undefined }) {
	const el = document.createElement(tag);

  // for..in / for over Object.keys().forEach() and Array#forEach: both of those are rewritten by
  // babel into core-js helpers, and this module is bundled into js/elements.js, which is loaded
  // blocking in <head> (see js/core/_component.js). Callers always pass object literals.
  for (const key in attributes) {
    el.setAttribute(key, attributes[key]);
  }

  if (html) {
    if (html instanceof Array) {
      for (let i = 0; i < html.length; i++) {
        el.insertAdjacentElement("beforeend", html[i]);
      }
    } else if (typeof html === "object") {
      el.insertAdjacentElement("beforeend", html);
    } else {
      el.insertAdjacentHTML("beforeend", html);
    }
  }

  if (text !== undefined) {
    el.textContent = text;
  }
  return el;
}
